export default __webpack_public_path__ + "static/media/plot_Legend.34258665.svg";